// Copyright (c) 2026 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { Form } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages<{ check: { count: number }; uncheck: { count: number } }>({
  check: {
    id: "check all shown entries",
    defaultMessage: "check all {count} shown entries",
  },
  uncheck: {
    id: "uncheck all shown entries",
    defaultMessage: "uncheck all {count} shown entries",
  },
});

interface ISelectAllCheckProps {
  id: string;
  checkedCount: number;
  totalCount: number;
  onChange: (checked: boolean) => void;
}

// table header checkbox to (un)check all shown entries, indeterminate if only some are checked
export default function SelectAllCheck(props: ISelectAllCheckProps) {
  const intl = useIntl();
  const isAllChecked = props.totalCount > 0 && props.checkedCount === props.totalCount;
  return (
    // plain input, as Form.Check only applies the title (tooltip) to its label
    <Form.Check.Input
      className="me-2"
      id={props.id}
      // describe the action of a click
      title={intl.formatMessage(isAllChecked ? messages.uncheck : messages.check, {
        count: props.totalCount,
      })}
      ref={(input: HTMLInputElement | null) => {
        if (input)
          input.indeterminate = props.checkedCount > 0 && props.checkedCount < props.totalCount;
      }}
      checked={isAllChecked}
      disabled={props.totalCount === 0}
      // avoid triggering the sorting of the column header
      onClick={(event) => event.stopPropagation()}
      onChange={(event) => props.onChange(event.currentTarget.checked)}
    />
  );
}
